// extracted by mini-css-extract-plugin
module.exports = {"Icon":"l2ecCHmzD93YhAJb_3fMb","Tooltip":"xyUwsu5FUZ1C-Obj9H3sy","AreaName":"_2hyoILbxVOj8qYrOe4D8Mu"};